import { SetupProgress } from 'models/SetupProgress';
import { serverUrl, getDefaultHeaders } from 'services/authService';

const parseErrorMessage = async (
  response: Response,
  fallback: string
): Promise<string> => {
  try {
    const errorData = await response.json();
    return errorData.message ?? errorData.detail ?? fallback;
  } catch {
    return fallback;
  }
};

const getSetupProgress = async (accessToken: string): Promise<SetupProgress> => {
  const response = await fetch(`${serverUrl}/setup-progress`, {
    headers: getDefaultHeaders(accessToken)
  });

  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(response, 'Failed to fetch setup progress')
    );
  }

  return response.json();
};

export { getSetupProgress };
